import React, { Component } from 'react'
import { isValidForm } from '../../utils/validation/CommonValidator';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faCircleNotch, faEye, faEyeSlash, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { checkParameters } from '../../utils/Encryption';
import { Navigate } from 'react-router-dom';
import ValidationText from '../../utils/validation/ValidationText';

export default class UserDetails extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            isLoading: false,
            showPassword: false,
            showRePassword: false,
            userid: 0,
            route: null,
            userForm: {
                iswebauthorized: false,
                islogbookauthorized: false,
                firstname: "",
                lastname: "",
                username: "",
                mobile: "",
                email: "",
                password: "",
                confirmPassword: "",
                roleId: 3,
            },
            roleOptions: [
                { label: 'Superadmin', value: 1 },
                { label: 'Admin', value: 2 },
                { label: 'House User', value: 3 },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "email"),
                    },
                    {
                        type: "email",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "valid email"),
                    },
                    {
                        type: "maxLength",
                        maxLength: 50,
                        message: "maximum length is 50"
                    },
                    {
                        type: "minLength",
                        minLength: 2,
                        message: "minimum length is 2",
                    },
                ],
                firstname: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "first name"),
                    },
                    {
                        type: "maxLength",
                        maxLength: 50,
                        message: "maximum lenth is 50"
                    },
                    {
                        type: "minLength",
                        minLength: 2,
                        message: "minimum lenth is 2",
                    },
                ],
                lastname: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "last name"),
                    },
                    {
                        type: "maxLength",
                        maxLength: 50,
                        message: "maximum lenth is 50"
                    },
                    {
                        type: "minLength",
                        minLength: 2,
                        message: "minimum lenth is 2",
                    },
                ],
                mobile: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "mobile no"),
                    },
                    {
                        type: "mobileNo",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "valid mobile no"),
                    },
                    {
                        type: "maxLength",
                        maxLength: 14,
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "valid mobile no"),
                    },
                    {
                        type: "minLength",
                        minLength: 7,
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "valid mobile no"),
                    },
                ],
                username: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "user name"),
                    },
                ],
                roleId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "role"),
                    },
                ],
            },
            passwordRule: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                },
                {
                    type: "password",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "strong password"),
                },
            ],
            confirmPasswordRule: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                },
                {
                    type: "compare",
                    message: "password and confirm password should be same",
                    compareEle: "password",
                },
            ],
        };
    }

    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let userid = Number(params.get(""))
        if (userid) {
            if (userid != null && userid > 0) {
                this.setState({ userid: userid }, () => {
                    this.getUserData(this.state.userid)
                });
            }
        }
    }

    getUserData = (id) => {
        this.adminServices.getUserData(id).then((response) => {
            if (response.success === 1 && response.data !== null) {
                let res = response.data[0];
                let details = this.state.userForm
                details.firstname = res.firstname;
                details.lastname = res.lastname;
                details.username = res.username;
                details.mobile = res.mobile;
                details.email = res.email;
                details.iswebauthorized = res.iswebauthorized === 1 ? true : false;
                details.islogbookauthorized = res.islogbookauthorized === 1 ? true : false;
                details.roleId = res.roleid;
                this.setState({ userForm: details });
            } else {
                this.swalServices.Error(response.msg);
            }
        });
    }

    isValidAllFields = () => {
        let valRule = { ...this.state.validationRules }
        if (this.state.userid > 0) {
            valRule.password = [];
            valRule.confirmPassword = [];
        } else {
            valRule.password = this.state.passwordRule;
            valRule.confirmPassword = this.state.confirmPasswordRule;
        }

        const newValidState = isValidForm(
            this.state.userForm,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.userForm;
        details[name] = value;
        this.setState({ userForm: details });
    };

    handleSelectChange = (event) => {
        let details = this.state.userForm;
        details.roleId = event.target.value;
        this.setState({ userForm: details });
    };

    handleToggle = () => {
        this.setState(prevState => ({
            userForm: {
                ...prevState.userForm,
                iswebauthorized: !prevState.userForm.iswebauthorized,
            },
        }));
    };

    handleLogbookToggle = () => {
        this.setState(prevState => ({
            userForm: {
                ...prevState.userForm,
                islogbookauthorized: !prevState.userForm.islogbookauthorized,
            },
        }));
    };

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    };

    toggleRePasswordVisibility = () => {
        this.setState((prevState) => ({
            showRePassword: !prevState.showRePassword,
        }));
    };

    createUser = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.userForm;
            let request = {}
            request.firstName = details.firstname;
            request.lastName = details.lastname;
            request.userName = details.username;
            request.mobile = details.mobile;
            request.email = details.email;
            request.password = details.password;
            request.confirmPassword = details.confirmPassword;
            request.roleId = details.roleId;
            request.isWebAuthorized = details.iswebauthorized ? 1 : 0;
            request.isLogbookAuthorized = details.islogbookauthorized ? 1 : 0;
            this.setState({ isLoading: true })
            this.adminServices.createUser(request).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/users-list" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    updateUser = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.userForm;
            let request = {}
            request.firstName = details.firstname;
            request.lastName = details.lastname;
            request.userName = details.username;
            request.mobile = details.mobile;
            request.email = details.email;
            request.roleId = details.roleId;
            request.isWebAuthorized = details.iswebauthorized ? 1 : 0;
            request.isLogbookAuthorized = details.islogbookauthorized ? 1 : 0;
            this.setState({ isLoading: true })
            this.adminServices.updateUser(request, this.state.userid).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/users-list" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    handleDelete = () => {
        this.swalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete ?`
        ).then((response) => {
            if (response === true) {
                this.setState({ isLoading: true });
                let id = this.state.userid
                this.adminServices.deleteUser(id).then((response) => {
                    if (response.success === 1) {
                        this.swalServices.Success(response.msg);
                        setTimeout(() => {
                            this.setState({ route: "/users-list" })
                        }, 1000);
                    } else {
                        this.swalServices.Error(response.msg);
                        this.setState({ isLoading: false });
                    }
                });
            }
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='user-details'>
                <div className='user-details-inner p-[30px] overflow-y-auto' style={{ height: "calc(100vh - 168.8px)" }}>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>
                            {this.state.userid > 0 ? "Edit user" : "Create user"}
                        </h1>
                        {/* <button className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px]'><FontAwesomeIcon className='w-5 h-5' icon={faUserPlus} />Add user</button> */}
                    </div>
                    <div className='user-entry grid grid-cols-3 gap-[30px]'>
                        <div className='user-info col-span-2'>
                            <div className='user-data p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                                <h2 className='text-[16px] font-semibold mt-0'>User details</h2>
                                <div className='user-data-inner grid grid-cols-2 gap-5'>
                                    <div className='input-grp !mb-0'>
                                        <label>First name:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter first name'
                                            id='firstname'
                                            name='firstname'
                                            className={`${this.state.validState?.error?.firstname ? "error" : ""}`}
                                            value={this.state.userForm.firstname}
                                            onChange={(event) => this.handleChange(event, "firstname")}
                                        />
                                        <ValidationText error={this.state.validState.error.firstname} />
                                    </div>
                                    <div className='input-grp !mb-0'>
                                        <label>Last name:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter last name'
                                            id='lastname'
                                            name='lastname'
                                            className={`${this.state.validState?.error?.lastname ? "error" : ""}`}
                                            value={this.state.userForm.lastname}
                                            onChange={(event) => this.handleChange(event, "lastname")}
                                        />
                                        <ValidationText error={this.state.validState.error.lastname} />
                                    </div>
                                    <div className='input-grp !mb-0'>
                                        <label>Username:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter username'
                                            id='username'
                                            name='username'
                                            className={`${this.state.validState?.error?.username ? "error" : ""}`}
                                            value={this.state.userForm.username}
                                            onChange={(event) => this.handleChange(event, "username")}
                                        />
                                        <ValidationText error={this.state.validState.error.username} />
                                    </div>
                                    <div className='input-grp !mb-0'>
                                        <label>Mobile no:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter mobile no'
                                            id='mobile'
                                            name='mobile'
                                            className={`${this.state.validState?.error?.mobile ? "error" : ""}`}
                                            value={this.state.userForm.mobile}
                                            onChange={(event) => this.handleChange(event, "mobile")}
                                        />
                                        <ValidationText error={this.state.validState.error.mobile} />
                                    </div>
                                    <div className='input-grp !mb-0 col-span-2'>
                                        <label>Email:</label>
                                        <input
                                            type='email'
                                            placeholder='Enter email address'
                                            id='email'
                                            name='email'
                                            className={`${this.state.validState?.error?.email ? "error" : ""}`}
                                            value={this.state.userForm.email}
                                            onChange={(event) => this.handleChange(event, "email")}
                                        />
                                        <ValidationText error={this.state.validState.error.email} />
                                    </div>
                                    {this.state.userid > 0 ? null :
                                        <>
                                            <div className='input-grp !mb-0 relative'>
                                                <label>Password:</label>
                                                <input
                                                    type={this.state.showPassword ? 'text' : 'password'}
                                                    placeholder='Enter password'
                                                    id='password'
                                                    name='password'
                                                    className={`${this.state.validState?.error?.password ? "error" : ""} pr-10`}
                                                    value={this.state.userForm.password}
                                                    onChange={(event) => this.handleChange(event, "password")}
                                                />
                                                <span
                                                    className='absolute right-3 top-[30px] cursor-pointer text-[#223645]'
                                                    onClick={this.togglePasswordVisibility}
                                                >
                                                    <FontAwesomeIcon icon={this.state.showPassword ? faEyeSlash : faEye} />
                                                </span>
                                                <ValidationText error={this.state.validState.error.password} />
                                            </div>
                                            <div className='input-grp !mb-0 relative'>
                                                <label>Re-enter password:</label>
                                                <input
                                                    type={this.state.showRePassword ? 'text' : 'password'}
                                                    placeholder='Re-enter password'
                                                    id='rePassword'
                                                    name='rePassword'
                                                    className={`${this.state.validState?.error?.confirmPassword ? "error" : ""} pr-10`}
                                                    value={this.state.userForm.confirmPassword}
                                                    onChange={(event) => this.handleChange(event, "confirmPassword")}
                                                />
                                                <span
                                                    className='absolute right-3 top-[30px] cursor-pointer text-[#223645]'
                                                    onClick={this.toggleRePasswordVisibility}
                                                >
                                                    <FontAwesomeIcon icon={this.state.showRePassword ? faEyeSlash : faEye} />
                                                </span>
                                                <ValidationText error={this.state.validState.error.confirmPassword} />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            {/* <div className='address-details p-5'>
                                <h2 className='text-[16px] font-semibold mt-0'>Address details</h2>
                                <div className='adress-details-inner grid grid-cols-2 gap-5'>
                                    <div className='input-grp !mb-0 col-span-2'>
                                        <label>Country:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter country'
                                            id='country'
                                            name='country'
                                            className={`${this.state.validState?.error?.country ? "error" : ""}`}
                                            value={this.state.userForm.country}
                                            onChange={(event) => this.handleChange(event, "country")}
                                        />
                                    </div>
                                    <div className='input-grp !mb-0 col-span-2'>
                                        <label>Email:</label>
                                        <input
                                            type='email'
                                            placeholder='Enter email address'
                                            id='email'
                                            name='email'
                                            className={`${this.state.validState?.error?.email ? "error" : ""}`}
                                            value={this.state.userForm.email}
                                            onChange={(event) => this.handleChange(event, "email")}
                                        />
                                    </div>
                                    <div className='input-grp !mb-0'>
                                        <label>City:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter city'
                                            id='city'
                                            name='city'
                                            className={`${this.state.validState?.error?.city ? "error" : ""}`}
                                            value={this.state.userForm.city}
                                            onChange={(event) => this.handleChange(event, "city")}
                                        />
                                    </div>
                                    <div className='input-grp !mb-0'>
                                        <label>Postal code:</label>
                                        <input
                                            type='text'
                                            placeholder='Enter postal code'
                                            id='postalCode'
                                            name='postalCode'
                                            className={`${this.state.validState?.error?.postalCode ? "error" : ""}`}
                                            value={this.state.userForm.postalCode}
                                            onChange={(event) => this.handleChange(event, "postalCode")}
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className='user-account h-fit p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                            <h2 className='text-[16px] font-semibold mt-0'>User account</h2>
                            <div className='user-account-inner'>
                                <div className='input-grp'>
                                    <label>User role:</label>
                                    <select value={this.state.userForm.roleId} onChange={this.handleSelectChange}>
                                        {this.state.roleOptions.map((role, index) => (
                                            <option key={index} value={role.value}>
                                                {role.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='input-grp !mb-0'>
                                    <label>User has web authorization?</label>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={this.state.userForm.iswebauthorized}
                                            onChange={this.handleToggle}
                                            value={this.state.userForm.iswebauthorized}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className='input-grp !mb-0'>
                                    <label>Allow Logbook Access?</label>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={this.state.userForm.islogbookauthorized}
                                            onChange={this.handleLogbookToggle}
                                            value={this.state.userForm.islogbookauthorized}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='sticky bottom-0 bg-white border-t border-slate-200 z-30 px-[30px] py-[30px] flex items-center justify-between'>
                    <div className='btn-left'>
                        <button
                            onClick={() => this.setState({ route: "/users-list" })}
                            className='font-medium text-[16px] text-[#223645] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#EBEBEB] hover:bg-[#dddddd] border-0 flex items-center gap-[5px]'>
                            <FontAwesomeIcon icon={faArrowLeftLong} className='w-5 h-5' />Back
                        </button>
                    </div>
                    <div className='btn-right flex items-center gap-5'>
                        {this.state.userid > 0 ?
                            <>
                                <button
                                    onClick={() => this.handleDelete()}
                                    className='font-medium text-[16px] text-[#EA3636] hover:text-[#ffffff] leading-[24px] px-[24px] py-[12px] rounded-[14px] border-0 bg-[#ffe8e8] hover:bg-[#EA3636] flex items-center gap-[5px]'>
                                    <FontAwesomeIcon icon={faTrashCan} className='w-5 h-5' />Delete
                                </button>
                                <button
                                    onClick={() => this.updateUser()}
                                    className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Update"}
                                </button>
                            </>
                            :
                            <button
                                onClick={() => this.createUser()}
                                className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Save"}
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}